import AdvanceLogoBlue from './advance-logo-blue.png';
import AdvanceLogoWhite from './advance-logo-white.png';
import AdvanceLoader from './advance-loader.gif';
import contact from './contact.png';
import faq from './faq.png';
const images = {
  AdvanceLogoBlue,
  AdvanceLogoWhite,
  contact,
  faq,
  AdvanceLoader
};
export default images;
//# sourceMappingURL=index.js.map